module.exports = __webpack_public_path__ + "img/8.3ba645f4.jpg";